import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Stepper } from "../core/Stepper";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { HouseIcon } from "../core/icons/Icons";
import { useStyles } from "../../useStyles";

export const IncreaseCurrentHousingUnitsForm: FC = () => {
    const classes = useStyles();
    const { values, setValues } = useFormModel<ChangeNames.INCREASE_CURRENT_HOUSING_UNITS>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<HouseIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Anzahl der Wohneinheiten
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 28 }}>
                            Geben Sie hier die Anzahl der Wohneinheiten ein.
                        </p>
                        <Stepper
                            allowNegative={false}
                            value={values.increaseCurrentHousingUnits.value.units || 0}
                            onValueChange={v =>
                                setValues(values => {
                                    values.increaseCurrentHousingUnits.value.units =
                                        v.floatValue ||
                                        values.increaseCurrentHousingUnits.value.units;
                                })
                            }
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
